import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css'
import { Base64 } from 'js-base64';


import toastr from "toastr";
import "toastr/build/toastr.min.css";

import {
  getSong as onGetSong,
  addSong as onAddSong,
  updateSong as onUpdateSong,
  deleteSong as onDeleteSong,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  document.title = "Podcast | TriMentor ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  // Form elemanlarının state'leri
  const [imageFile, setImageFile] = useState('');
  const [mediaFile, setMediaFile] = useState('');
  const [mediaType, setMediaType] = useState(''); // <-- YENİ: Medya tipini (audio/video) saklamak için state
  const [htmlDataLong, setHtmlDataLong] = useState('');
  const [category, setCategory] = useState([]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: (contactEdit && contactEdit.Song_Title) || "",
      artist: (contactEdit && contactEdit.Song_Artist) || "",
      duration: (contactEdit && contactEdit.Song_Duration) || "",
      Song_Category_ID: (contactEdit && contactEdit.Song_Category_ID) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen başlığı giriniz."),
      artist: Yup.string().required("Lütfen artist adını giriniz."),
      Song_Category_ID: Yup.string().required("Lütfen bir kategori seçiniz."),
    }),

    onSubmit: (values) => {
      const payload = {
        Song_Title: values.title,
        Song_Category_ID: values.Song_Category_ID,
        Song_Link: mediaFile,
                Song_Image: imageFile,
                Song_Artist: values.artist,
                Song_Duration: values.duration,
        Song_Type: mediaType, // <-- YENİ: Medya tipi payload'a eklendi
      };

      if (isEdit) {
        const updatePodcast = {
          ID: contactEdit.ID,
          ...payload
        };
        dispatch(onUpdateSong(updatePodcast));
      } else {
        dispatch(onAddSong(payload));
      }
      toggle();
    },
  });

  const { users: podcasts } = useSelector(state => ({
    users: state.contacts.song,
  }));

  const resetModal = () => {
    setImageFile('');
    setMediaFile('');
    setMediaType(''); // <-- YENİ: Modal kapanınca medya tipi de sıfırlanır
    setHtmlDataLong('');
    setEditContact(null);
    setIsEdit(false);
    validation.resetForm();
  };

  const toggle = () => {
    setModal(!modal);
  };

  function uploadAdapter(loader) {
    return {
      upload: () => new Promise((resolve, reject) => {
        loader.file.then(file => {
          const body = new FormData();
          body.append('dataFile', file);
          axios.post(`https://berlinadmin.stechomeyazilim.info:9091/uploadfile`, body, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(response => {
            resolve({ default: `https://megasubdomain.stechomeyazilim.info/${response.data.file.filename}` });
          })
          .catch(error => reject(error));
        });
      })
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = loader => uploadAdapter(loader);
  }

  const columns = useMemo(
    () => [
      { Header: "#", Cell: () => <input type="checkbox" className="form-check-input" /> },
      {
        Header: "Foto",
        accessor: "Song_Image",
        Cell: ({ cell: { value } }) => (
          value ? (
            <img className="rounded-circle avatar-xs" src={'https://megasubdomain.stechomeyazilim.info/' + value} alt="" />
          ) : (
            <div className="avatar-xs"><span className="avatar-title rounded-circle">P</span></div>
          )
        ),
      },
      { Header: "Başlık", accessor: "Song_Title" },
      { Header: "Kategori", accessor: "Song_Category.Song_Category_Text" },
      { Header: "Süre", accessor: "Song_Duration" },
      { Header: "Sahibi", accessor: "Song_Artist" },
      {
        Header: "İşlemler",
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <Link to="#" className="text-success" onClick={() => handleUserClick(row.original)}>
              <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${row.id}`} />
              <UncontrolledTooltip placement="top" target={`edittooltip-${row.id}`}>Düzenle</UncontrolledTooltip>
            </Link>
            <Link to="#" className="text-danger" onClick={() => onClickDelete(row.original)}>
              <i className="mdi mdi-delete font-size-18" id={`deletetooltip-${row.id}`} />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${row.id}`}>Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    const _getAuthData = async () => {
      try {
        const res = await axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getSongCategoryEfso/select/`);
        setCategory(res.data);
      } catch (error) {
        console.error("Kategori verisi alınamadı:", error);
      }
    };
    _getAuthData();
    if (isEmpty(podcasts)) {
      dispatch(onGetSong());
    }
  }, [dispatch, podcasts]);
  
  const handleUserClick = (podcast) => {
    setIsEdit(true);
    setEditContact(podcast);
    validation.setValues({
        title: podcast.Song_Title,
        artist: podcast.Song_Artist,
        duration: podcast.Song_Duration,
        Song_Category_ID: podcast.Song_Category_ID,
    });
    setImageFile(podcast.Song_Image || '');
    
    const link = podcast.Song_Link || '';
    setMediaFile(link);

    // <-- YENİ: Düzenleme modunda, dosya uzantısından medya tipini anla
    if (link.endsWith('.mp4')) {
      setMediaType('video');
    } else if (link.endsWith('.mp3')) {
      setMediaType('audio');
    } else {
      // Eğer API'den `Song_MediaType` geliyorsa onu kullanmak daha iyidir:
      // setMediaType(podcast.Song_MediaType || '');
      setMediaType('');
    }

    setHtmlDataLong(podcast.Song_Description ? Base64.decode(podcast.Song_Description) : '');
    setModal(true);
  };
  
  const handleAddClick = () => {
    resetModal();
    setIsEdit(false);
    setModal(true);
  }

  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = (podcast) => {
    setContact(podcast);
    setDeleteModal(true);
  };
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteSong(contact.ID));
    }
    setDeleteModal(false);
  };

  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body };
  };
  

  function showToast(title, message, isSuccess) {
    toastr.options = {
        positionClass: "toast-top-right",
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        newestOnTop: true
    };
    if (isSuccess) {
        toastr.success(message, title);
    } else {
        toastr.error(message, title);
    }
  }
  // <-- YENİ: Medya yükleme durumunu takip eden ve TİPİNİ belirleyen özel fonksiyon
  const handleMediaChangeStatus = ({ meta, xhr, remove }, status) => {
    if (status === 'done') {
      const result = JSON.parse(xhr.response);
      setMediaFile(result.file.filename); // Dosya adını state'e kaydet

      // Dosyanın MIME türüne göre medya tipini state'e kaydet
      if (meta.type.startsWith('audio/')) {
        setMediaType('audio');
      } else if (meta.type.startsWith('video/')) {
        setMediaType('video');
      } else {
        setMediaType('');
      }

            showToast("Yükleme Başarılı", `'${meta.name}' adlı medya dosyası yüklendi.`, true);

    }
    if (status === 'removed') {
      setMediaFile('');
      setMediaType('');
    }
  };

  // Bu fonksiyon sadece resim yükleme için kaldı
const handleImageChangeStatus = ({ meta, xhr, remove }, status) => { // 'meta' parametresini ekleyin
    if (status === 'done') {
        const result = JSON.parse(xhr.response);
        setImageFile(result.file.filename);
        // <-- BURAYA EKLEYİN
        showToast("Yükleme Başarılı", `'${meta.name}' adlı resim dosyası yüklendi.`, true);
    }
    if (status === 'removed') {
        setImageFile('');
    }
  };

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteUser} onCloseClick={() => setDeleteModal(false)} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Podcast Listesi" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={podcasts}
                    isGlobalFilter={true}
                    isAddSong={true}
                    handleOrderClicks={handleAddClick}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                  <Modal isOpen={modal} toggle={toggle} size="lg" onClosed={resetModal}>
                    <ModalHeader toggle={toggle} tag="h4">{isEdit ? "Podcast Düzenle" : "Podcast Ekle"}</ModalHeader>
                    <ModalBody>
                      <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Podcast Kategori</Label>
                              <Input
                                name="Song_Category_ID"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.Song_Category_ID}
                                invalid={!!(validation.touched.Song_Category_ID && validation.errors.Song_Category_ID)}
                              >
                                <option value="">Lütfen Seçim Yapınız</option>
                                {category.map(item => (
                                  <option value={item.ID} key={item.ID}>{item.Song_Category_Text}</option>
                                ))}
                              </Input>
                              {validation.touched.Song_Category_ID && validation.errors.Song_Category_ID && (
                                <FormFeedback type="invalid">{validation.errors.Song_Category_ID}</FormFeedback>
                              )}
                            </div>

                            {['title', 'artist', 'duration'].map(field => (
                                <div className="mb-3" key={field}>
                                <Label className="form-label text-capitalize">{field === "title" ? "Başlık" : (field === "artist" ? "Artist" : "Süre (Örn: 15:24)")}</Label>
                                <Input
                                    name={field}
                                    type="text"
                                    placeholder={field === 'duration' ? "Örn: 15:24" : ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values[field]}
                                    invalid={!!(validation.touched[field] && validation.errors[field])}
                                />
                                {validation.touched[field] && validation.errors[field] && (
                                    <FormFeedback type="invalid">{validation.errors[field]}</FormFeedback>
                                )}
                                </div>
                            ))}
                            
                            <div className="mb-3">
                                <Label>Görsel</Label>
                                {isEdit && imageFile && <div className="mb-2 text-muted">Mevcut Dosya: {imageFile}</div>}
                                <Dropzone
                                    getUploadParams={getUploadParams}
                                    onChangeStatus={handleImageChangeStatus}
                                    maxFiles={1}
                                    multiple={false}
                                    accept="image/*"
                                    inputContent="Resim dosyası sürükleyin veya seçin"
                                />
                            </div>

                            <div className="mb-3">
                                <Label>Medya Dosyası (MP3 veya MP4)</Label>
                                {isEdit && mediaFile && <div className="mb-2 text-muted">Mevcut Dosya: {mediaFile} ({mediaType})</div>}
                                <Dropzone
                                    getUploadParams={getUploadParams}
                                    onChangeStatus={handleMediaChangeStatus} // <-- Özel fonksiyonu kullan
                                    maxFiles={1}
                                    multiple={false}
                                    accept="audio/mp3,video/mp4"
                                    inputContent="MP3 veya MP4 dosyası sürükleyin veya seçin"
                                />
                            </div>
                            
                   
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button type="submit" className="btn btn-success save-user">Kaydet</button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);